import { render } from "./GameHome.vue?vue&type=template&id=23a17aa6&ts=true"
import script from "./GameHome.vue?vue&type=script&lang=ts"
export * from "./GameHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__